"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconPenWrite = /*#__PURE__*/
function (_Icon) {
  _inherits(IconPenWrite, _Icon);
  function IconPenWrite(props) {
    var _this;
    _classCallCheck(this, IconPenWrite);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconPenWrite).call(this, props));
    _this.name = 'IconPenWrite';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("path", {
      className: "pen-write_svg__path0",
      d: "M19 13a1 1 0 00-1 1v7a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h7a1 1 0 000-2H3a3 3 0 00-3 3v18a3 3 0 003 3h14a3 3 0 003-3v-7a1 1 0 00-1-1z"
    }), _react2.default.createElement("path", {
      className: "pen-write_svg__path1",
      d: "M8.73 12.521a.5.5 0 00-.353.361l-.557 2.237-1.252 1.252a.75.75 0 000 1.061.76.76 0 001.06 0l1.264-1.262 2.207-.555a.5.5 0 00.36-.35.5.5 0 00-.127-.487L9.217 12.65a.5.5 0 00-.487-.129z"
    }), _react2.default.createElement("path", {
      className: "pen-write_svg__path2",
      d: "M23.707.293a1 1 0 00-1.414 0l-.9.9a2.011 2.011 0 00-1.533.208l-.052-.051a3 3 0 00-4.235.006l-3.612 3.605a1 1 0 000 1.414 1.013 1.013 0 001.415 0L17 2.761a1 1 0 011.407.007l-.707.707a.5.5 0 000 .707L19.818 6.3a.5.5 0 00.707 0l1.768-1.768a2 2 0 00.517-1.93l.9-.9a1 1 0 00-.003-1.409z"
    }), _react2.default.createElement("path", {
      className: "pen-write_svg__path3",
      d: "M12.4 14.22a.5.5 0 00.353-.147l6.356-6.355a.5.5 0 000-.707L16.99 4.889a.514.514 0 00-.707 0l-6.356 6.356a.5.5 0 000 .707l2.121 2.121a.5.5 0 00.352.147z"
    }));
    return _this;
  }
  return IconPenWrite;
}(_Icon3.default);
exports.default = IconPenWrite;